<!--
 * Description  :
 * Date         :2021-12-15 15:26:54
 * LastEditors  :chenjia
 * LastEditTime :2022-06-10 14:23:50
 * FilePath     :\abackup-pay\src\views\Invoice.vue
-->
<template>
  <div>
    <div class="invoice-x">
      <div class="query">
        <h3>查询订单信息</h3>
        <el-form
          :model="queryForm"
          ref="queryForm"
          label-width="130px"
          class="query-form"
          :rules="queryRules"
        >
          <el-form-item label="输入订单号:" prop="orderId">
            <el-input v-model="queryForm.orderId" autocomplete="off"></el-input>
          </el-form-item>
          <el-button
            :loading="btnLoadingQuery"
            type="primary"
            class="btn-org"
            @click="queryOrdersFn('numberValidateForm')"
          >
            查询订单
          </el-button>
        </el-form>
      </div>
      <div class="detail-x" v-if="orderInfo">
        <h3>确认订单详情：</h3>
        <div class="detail-mn">
          <h4>联系人信息</h4>
          <ul class="detail-ls">
            <li>
              <span class="key">姓名：</span>
              <span class="value">{{ orderInfo.name }}</span>
            </li>
            <li>
              <span class="key">手机：</span>
              <span class="value">{{ orderInfo.phone }}</span>
            </li>
            <li>
              <span class="key">邮箱：</span>
              <span class="value">{{ orderInfo.email }}</span>
            </li>
          </ul>
          <h4>订单信息：</h4>
          <ul class="detail-ls">
            <li>
              <span class="key">订单号：</span>
              <span class="value">{{ orderInfo.order_no }}</span>
            </li>
            <li>
              <span class="key">软件名：</span>
              <span class="value">{{ orderInfo.show_name }}</span>
            </li>
            <li>
              <span class="key">版本：</span>
              <span class="value">{{ orderInfo.show_version }}</span>
            </li>
            <li>
              <span class="key">软件数量：</span>
              <span class="value">{{
                orderInfo.data && orderInfo.data.length
              }}</span>
            </li>
            <li>
              <span class="key">注册码：</span>
              <span class="value">{{ orderInfo.liceseCode }}</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="invoice" v-if="orderInfo">
        <h3>开具发票：</h3>
        <el-form
          label-width="125px"
          :model="tax"
          class="form"
          :rules="rules"
          ref="taxForm"
          v-if="!success.isSuccess"
        >
          <el-form-item class="email-x" prop="email" label="接收发票邮件:">
            <el-input v-model="tax.email"></el-input>
          </el-form-item>
          <div class="invoice-mn">
            <el-form-item
              label=""
              prop="invoiceType"
              style="width: 100%"
              class="radio-bx"
            >
              <el-radio v-model="tax.invoiceType" label="1"
                >个人普通发票</el-radio
              >
              <el-radio v-model="tax.invoiceType" label="2"
                >企业普通发票</el-radio
              >
              <el-radio v-model="tax.invoiceType" label="3"
                >企业增值税专票</el-radio
              >
            </el-form-item>

            <div class="invoice-btm">
              <el-form-item
                :label="
                  isAddTax
                    ? '发票抬头:'
                    : tax.invoiceType == 1
                    ? '个人名称:'
                    : '企业名称:'
                "
                prop="name"
              >
                <el-input v-model="tax.name"></el-input>
              </el-form-item>

              <el-form-item
                :label="isAddTax ? '纳税人识别号:' : '税号:'"
                prop="taxNum"
              >
                <el-input v-model="tax.taxNum"></el-input>
              </el-form-item>

              <div class="addedTax-bx" v-if="isAddTax">
                <el-form-item label="账号:" prop="bankAccount">
                  <el-input v-model="tax.bankAccount"></el-input>
                </el-form-item>

                <el-form-item label="开户行:" prop="bankName">
                  <el-input v-model="tax.bankName"></el-input>
                </el-form-item>
                <el-form-item label="注册地址:" prop="companyAddress">
                  <el-input v-model="tax.companyAddress"></el-input>
                </el-form-item>
                <el-form-item label="注册电话:" prop="telphone">
                  <el-input v-model="tax.telphone"></el-input>
                </el-form-item>
                <div class="line"></div>
                <el-form-item label="收件人:" prop="receiver">
                  <el-input v-model="tax.receiver"></el-input>
                </el-form-item>
                <el-form-item label="收件人手机:" prop="receiverMobile">
                  <el-input v-model="tax.receiverMobile"></el-input>
                </el-form-item>
                <el-form-item label="收件人地址:" prop="receiverAddress">
                  <el-input v-model="tax.receiverAddress"></el-input>
                </el-form-item>
              </div>

              <el-form-item class="btn-bx">
                <!-- <div class="btn-bx"> -->
                <el-button
                  class="btn btn-bl-gry"
                  ref="ruleFormCancl"
                  @click="closeInvoice"
                  >取消</el-button
                >
                <el-button
                  :loading="btnLoadingSubmit"
                  class="btn btn-org"
                  type="primary"
                  @click="handleSubmit('taxForm')"
                  >确认开票</el-button
                >
                <el-button
                  style="display:none"
                  class="btn btn-bl-gry"
                  ref="ruleFormRef"
                  @click="resetForm('taxForm')"
                  >重置</el-button
                >

                <!-- </div> -->
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
    </div>
    <div class="contact">
      <h3 class="f-tac">联系我们</h3>
      <div class="g-cnt f-dpf">
        <div class="img-bx">
          <img
            src="https://www.abackup.com/assets/images/icon/wx_dl.png"
            width="180"
            height="180"
            alt=""
          />
        </div>
        <div class="txt-bx">
          <h4>微信扫一扫，联系我们工作人员</h4>
          <p>联系电话：028-61533037</p>
          <p>联系邮件：aomeitech@163.com</p>
          <p>
            联系地址：四川省成都市锦江区下沙河铺街59号(联合广场)1栋2单元6层
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import { defineComponent } from '@vue/composition-api'
import * as api from "@/api/api";
import { mapMutations } from "vuex";
export default {
  name: "Invoice",
  props: {},
  data() {
    return {
      btnLoadingSubmit: false,
      btnLoadingQuery: false,
      queryRules: {
        orderId: [{ required: true, message: "请输入", trigger: "blur" }],
      },
      queryForm: {
        orderId: "",
      },
      tax: {
        email: "",
        invoiceType: "1",
        name: "",
        taxNum: "",
        companyAddress: "",
        telphone: "",
        bankName: "",
        bankAccount: "",
        receiver: "",
        receiverMobile: "",
        receiverAddress: "",
        taxDesc: "",
      },
      rules: {
        email: [
          { required: true, message: "请输入", trigger: "blur" },
          {
            type: "email",
            message: "请输入正确的邮箱地址",
            trigger: "blur",
          },
        ],
        name: [{ required: true, message: "请输入", trigger: "blur" }],
        taxNum: [
          { required: true, message: "请输入", trigger: "blur" },
          {
            pattern: /^[A-Z0-9]{15}$|^[A-Z0-9]{17}$|^[A-Z0-9]{18}$|^[A-Z0-9]{20}$/, // 15或者17或者18或者20位字母、数字组成
            message: "您输入得税号格式不正确",
            trigger: "blur",
          },
        ],
        bankAccount: [{ required: true, message: "请输入", trigger: "blur" }],
        bankName: [{ required: true, message: "请输入", trigger: "blur" }],
        companyAddress: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
        telphone: [
          { required: true, message: "请输入", trigger: "blur" },
          {
            pattern: /^((0\d{2,3}-\d{7,8})|(1[3-9]\d{9}))$/,
            message: "请输入合法手机号/电话号",
            trigger: "blur",
          },
        ],
        receiver: [{ required: true, message: "请输入", trigger: "blur" }],
        receiverMobile: [
          { required: true, message: "请输入", trigger: "blur" },
          {
            pattern: /^((0\d{2,3}-\d{7,8})|(1[3-9]\d{9}))$/,
            message: "请输入合法手机号/电话号",
            trigger: "blur",
          },
        ],
        receiverAddress: [
          { required: true, message: "请输入", trigger: "blur" },
        ],
      },
      success: {
        isSuccess: false,
        content: "",
      },
    };
  },
  computed: {
    isAddTax: function() {
      let isAddTax = false;
      if (this.tax.invoiceType == "3") {
        return (isAddTax = true);
      }
      return isAddTax;
    },
    type: function() {
      let num = this.isAddTax ? "1" : "0";
      return num;
    },
    orderInfo() {
      if (this.$store.state.orderInfo !== null) {
        console.log(this.$store.state.orderInfo, 88888);
        const rawData = JSON.parse(this.$store.state.orderInfo);
        const dealData = (({
          order_no,
          show_name,
          show_version,
          email,
          phone,
          name,
          liceseCode,
          data,
        }) => {
          //处理序列号
          liceseCode = "";
          data.forEach((n) => {
            n.serial_numbers.forEach((item) => {
              // liceseCode.push(item);
              liceseCode = liceseCode + item + "、";
            });
          });
          // licese = liceseCode
          liceseCode = liceseCode.substring(0, liceseCode.lastIndexOf("、"));
          return {
            order_no,
            show_name,
            show_version,
            email,
            phone,
            name,
            liceseCode,
            data,
          };
        })(rawData);

        return dealData;
      } else {
        return null;
      }
    },
  },
  methods: {
    ...mapMutations(["updateOrderInfo"]),
    handleSubmit(formName) {
      if (this.orderInfo != null) {
        let orderNum = this.orderInfo ? this.orderInfo.order_no : '';
        let obj = {
          is_vat: this.type,
          receive_email: this.tax.email,
          invoice_title: this.tax.name,
          invoice_tax_no: this.tax.taxNum,
          vat_company_address: this.tax.companyAddress,
          vat_telphone: this.tax.telphone,
          vat_bank_name: this.tax.bankName,
          vat_bank_account: this.tax.bankAccount,
          receiver: this.tax.receiver,
          receiver_mobile: this.tax.receiverMobile,
          receiver_address: this.tax.receiverAddress,
          vat_desc: this.tax.taxDesc,
        };
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.btnLoading = true;
            api
              .drawBbill(orderNum, obj)
              .then((resp) => {
                this.resetForm("taxForm");

                if (resp.code == 200 || resp.code == 412) {
                  const type = resp.code == 200 ? "succes" : "warning";
                  this.$confirm(resp.msg, "提示", {
                    confirmButtonText: "确定",
                    type: type,
                    center: true,
                    showCancelButton: false,
                  });
                } else {
                  this.$message({
                    type: "error",
                    message: resp.msg,
                    offset: 100,
                  });
                }
              })
              .finally(() => {
                this.btnLoading = false;
              });
          } else {
            //验证不通过，定位到第一个非法位置
            setTimeout(() => {
              let isError = document.getElementsByClassName("is-error");
              isError[0].querySelector("input").focus();
            }, 100);
            return false;
          }
        });
      } else {
        this.$message({
          type: "warning",
          message: '请先输入订单号查询订单',
          offset: 100,
        });
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    closeInvoice() {
      this.resetForm("taxForm");
    },
    initInfo() {
      if (this.orderInfo !== null) {
        this.queryForm.orderId = this.orderInfo.order_no;
      }
    },
    queryOrdersFn() {
      this.$refs["queryForm"].validate((valid) => {
        if (valid) {
          this.btnLoadingQuery = true;
          api
            .queryOrders(this.queryForm.orderId)
            .then((resp) => {
              if (resp.code == 200) {
                this.updateOrderInfo(JSON.stringify(resp.data));
              } else if (resp.code == 404) {
                this.$message({
                  showClose: true,
                  message: resp.msg,
                  type: "error",
                });
              } else if (resp.code == 403) {
                this.$message({
                  showClose: true,
                  message: resp.msg,
                  type: "warning",
                });
              }
            })
            .finally(() => {
              this.btnLoadingQuery = false;
            });
        }
      });
    },
  },
  created() {
    this.initInfo();
  },
};
</script>
<style lang="less" scoped>
.invoice-x {
  background: #fff;
  padding: 40px 60px;
  border-radius: 10px;
}
.query {
  padding-bottom: 35px;
  margin-bottom: 50px;
  border-bottom: 1px solid #dcdfe6;
  &-form {
    display: flex;
    vertical-align: middle;
    max-width: 810px;
    input {
      width: 225px;
      font-size: 18px;
    }
    .el-form-item {
      // width: 330px;
      margin-right: 20px;
      flex: 1;
    }
    /deep/ .el-form-item__label {
      font-size: 18px;
    }

    .btn-org {
      width: 200px;
      height: 40px;
      line-height: 30px;
      font-size: 20px;
      &:hover {
        opacity: 0.9;
      }
    }
  }
}
.detail {
  &-mn {
    margin-top: 30px;
    padding: 30px 20px;
    border-radius: 10px;
    border: 1px solid #dcdfe6;
    h4 {
      font-size: 18px;
      margin-bottom: 25px;
    }
  }
  &-ls {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    font-size: 18px;
    li {
      width: 45%;
      margin-bottom: 32px;
    }
    .key {
      display: inline-block;
      min-width: 90px;
      text-align: right;
    }
    .value {
      display: inline-block;
      border-radius: 5px;
      padding: 5px 10px;
      background: #eee;
      width: calc(100% - 90px);
      max-width: 290px;
      min-height: 39px;
      vertical-align: middle;
      font-size: 16px;
      color: #888;
      word-break: break-all;
    }
  }
}
.invoice {
  margin-top: 35px;
  font-size: 18px;
  .btn {
    line-height: 30px;
    height: 50px;
    width: 200px;
    vertical-align: middle;
  }
  /deep/ .el-form-item__label {
    font-size: 16px;
  }
  .email-x {
    max-width: 400px;
  }
  &-mn {
    border: 1px solid #dcdfe6;
    border-radius: 10px;
    text-align: center;
    padding-bottom: 50px;
  }
  &-btm {
    padding: 0 20px;
    max-width: 700px;
    margin: 0 auto;
    /deep/ .el-form-item__content {
      max-width: 600px;
    }
  }
  .radio-bx {
    border-bottom: 1px solid #dcdfe6;
    margin-bottom: 40px;
    /deep/ .el-form-item__content {
      margin-left: 0 !important;
    }
  }
  /deep/ .el-radio {
    width: 30%;
    padding: 28px 0 20px;
    position: relative;
    &__input {
      display: none;
      &.is-checked + .el-radio__label {
        font-weight: bold;
      }
      &.is-checked + .el-radio__label::before {
        background: #203491;
      }
    }
    &__label {
      font-size: 20px;
      color: #333;
      padding-left: 0;
      position: relative;
      &::before {
        content: "";
        position: absolute;
        width: 100%;
        height: 8px;
        background: transparent;
        bottom: -17px;
      }
    }
  }
}
@media (max-width: 992px) {
  .detail {
    &-ls {
      li {
        width: 100%;
      }
      .value {
        max-width: 100%;
      }
    }
  }
}
@media (max-width: 767px) {
  .invoice-x {
    padding: 40px 20px;
  }
  .query {
    &-form {
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .el-form-item {
        width: 100%;
        margin-right: 0;
      }
      .el-form-item__content {
        margin-left: 0 !important;
      }
    }
  }
  /deep/ .el-radio {
    margin-right: 0;
  }
  /deep/ .btn-bx .el-form-item__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    .el-button + .el-button {
      margin: 10px 0 0;
    }
  }
}
@media (max-width: 600px) {
  /deep/ .invoice .radio-bx .el-form-item__content {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  /deep/ .invoice .el-form-item__label {
    text-align: left;
  }
  .detail-ls {
    .key {
      text-align: left;
    }
    .value {
      width: 100%;
    }
  }
  /deep/ .el-form-item__content {
    margin-left: 0 !important;
  }
}
</style>
